import React from 'react';
import { ChildrenStoreData, TimelineData } from "src/shared/types/src";
import { useAppSelector } from "../../services/store";
import { getCurrentChild } from "src/shared/redux-state/src";
import LocalImages from 'src/app/static';
import { ACTIVITY_TYPE } from "src/shared/config/src";
import { dateFormatter } from "src/shared/utils/src";
import TextRenderer from './TextRenderer';

type IProps = { 
    timelineItem: TimelineData 
}

const RegistryInternalDetails: React.FC<IProps> = ({ timelineItem }) => {

    const currentChild: ChildrenStoreData = useAppSelector(getCurrentChild);

    return (
        <>
            <div className='d-flex align-items-center'>
                <div className='section-with-img flex-1 pd-r-15'>
                    <div className='section-img'>
                        <img src={LocalImages.timelineRegistryIcon} alt="timeline registry icon"/>
                    </div>
                    <div className='fs-12 fw-semibold text-black flex-1 pd-l-10'>
                        { currentChild.name }
                        {
                            timelineItem.activityType !== ACTIVITY_TYPE.DAILY_DIARY_HOLIDAY ?
                            <span className='fw-regular pd-l-5'>
                                { (timelineItem.activityType === ACTIVITY_TYPE.SIGN_IN) ? 'came in at ' : 'went out at ' }
                                { dateFormatter(timelineItem.timestamp, 'hh:mm aaa') }
                            </span>
                            : null
                        }
                    </div>
                </div>
                <div>
                    <p className='mg-b-0 fs-12 fw-regular text-gray-300'>
                        { timelineItem.activityType === ACTIVITY_TYPE.DAILY_DIARY_HOLIDAY ? (timelineItem.content || 'Holiday')  : '' }
                    </p>
                </div>
            </div>
            {
                timelineItem?.details?.notes ?
                <div className='mg-t-13 fs-12 text-black'>
                    Notes: <TextRenderer text={ timelineItem.details.notes || 'N/A' } />
                </div> : null
            }
        </>
    )
}

export default RegistryInternalDetails;